<template>
  <div>
    <TitleWidget class="text-center">
      {{ business === 1 ? "Alugar" : "Comprar" }}
    </TitleWidget>

    <DistrictsFeaturedWidget class="mt-3 mt-md-6" v-bind="$props" />

    <BasicSearchForm class="mt-3 mt-md-6" v-bind="$props" />
  </div>
</template>

<script>
import TitleWidget from "./TitleWidget.vue";
import DistrictsFeaturedWidget from "./DistrictsFeaturedWidget.vue";
import BasicSearchForm from "../forms/BasicSearchForm.vue";

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  computed: {
    query() {
      return this.$route.query;
    },
    filters() {
      return this.$route.query;
    },
    districtsSelecteds: {
      get() {
        return this.query.d
          ? this.query.d.split(",").map((v) => parseInt(v))
          : [];
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.d = v.join(",");
        else delete query.d;

        this.$router.push({ query });
      },
    },
  },
  components: {
    TitleWidget,
    DistrictsFeaturedWidget,
    BasicSearchForm,
  },
};
</script>

<style lang="scss" scoped>
.chip-group::v-deep {
  .v-slide-group__content {
    display: flex;
    justify-content: center;
    padding-right: 14px;
    padding-left: 14px;
  }

  .v-chip {
    clip-path: polygon(24px 0%, 100% 0%, calc(100% - 24px) 100%, 0% 100%);
    border-radius: 0 !important;
    padding: 12px 30px;
    margin: 4px -12px 4px 0;
  }

  @media screen and (max-width: 600px) {
    .v-chip {
      clip-path: polygon(18px 0%, 100% 0%, calc(100% - 18px) 100%, 0% 100%);
      padding: 8px 22px;
      margin: 4px -10px 4px 0;
    }
  }
}
</style>
